import React from 'react';
import { Star } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    name: 'Camila S.',
    info: '28 años - Buenos Aires',
    text: 'Llevaba AÑOS queriendo empezar y nunca sabía por dónde. Con este grimorio hice mi primer ritual de protección con ruda el mismo día que lo descargué. Lloré. Se sintió como volver a casa.'
  }, {
    name: 'Valentina R.',
    info: '34 años - Córdoba',
    text: 'Lo que más me gustó es que no te dice comprá salvia blanca importada. Te dice usá el romero que tenés en la maceta. Por fin algo real y para nosotras, no traducido del inglés.'
  }, {
    name: 'Lucía M.',
    info: '31 años - Rosario',
    text: 'Soy re escéptica y no me va lo místico místico. Pero este grimorio tiene un enfoque práctico que me encantó. Los rituales son como meditaciones con intención. Me sirven para bajar la ansiedad.'
  }, {
    name: 'Martina L.',
    info: '22 años - Mendoza',
    text: 'Vivo con mi familia católica y no puedo tener altar ni velas. Con este grimorio practico desde el celular y nadie se entera. El grupo de WhatsApp es hermoso, me sentí acompañada por primera vez.'
  }, {
    name: 'Florencia G.',
    info: '38 años - CABA',
    text: 'Compré 4 libros de brujería antes y ninguno me enganchó. Este es distinto porque te dice exactamente qué hacer, con qué y cuándo. El calendario lunar del hemisferio sur es un golazo.'
  }, {
    name: 'Sofía P.',
    info: '26 años - La Plata',
    text: 'Las plantillas son hermosas. Por fin tengo mi grimorio ordenado. Antes escribía en cuadernos sueltos y perdía todo. La guía de tarot me ayudó un montón a entender las cartas sin miedo.'
  }, {
    name: 'Agustina V.',
    info: '41 años - Mar del Plata',
    text: 'Dudé en comprarlo porque pensé que era para chicas más jóvenes, pero me sorprendió la profundidad. Es una herramienta de autoconocimiento preciosa. Lo recomiendo 100%.'
  }, {
    name: 'Micaela D.',
    info: '29 años - Neuquén',
    text: 'El herbario local es todo lo que está bien. Fui a la verdulería, compré laurel y romero, y ya pude hacer mi primer limpieza energética. Súper claro y al pie.'
  }];
  return <section className="py-20 px-4 relative z-10 bg-mystic-surface/30" data-id="element-236">
      <div className="max-w-6xl mx-auto" data-id="element-237">
        <div className="text-center mb-16" data-id="element-238">
          <h2 className="font-cormorant text-4xl md:text-5xl text-gold-light mb-4" data-id="element-239">
            Lo que dicen quienes ya lo usan ✨
          </h2>
          <p className="text-xl text-text-soft font-outfit" data-id="element-240">
            Mujeres que dejaron de dar vueltas y empezaron
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-241">
          {testimonials.map((t, i) => <div key={i} className="surface-gradient p-6 rounded-xl border border-gold-dark/20 hover:border-gold-dark/50 transition-colors" data-id="element-242">
              <div className="flex gap-1 mb-4" data-id="element-243">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-gold-primary text-gold-primary" data-id="element-244" />)}
              </div>
              <p className="text-text-primary mb-6 italic leading-relaxed" data-id="element-245">
                "{t.text}"
              </p>
              <div className="border-t border-gold-dark/20 pt-4" data-id="element-246">
                <p className="font-medium text-gold-light" data-id="element-247">{t.name}</p>
                <p className="text-sm text-text-muted" data-id="element-248">{t.info}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};